module.exports = __webpack_public_path__ + "static/full01-c02d14be0448fbb23f9333157a853a8b.png";